import { create } from 'zustand';
import type { RewardedPlacement } from '@/api/types';

/**
 * App chrome shown while an ad is on screen. `interstitial` is the
 * between-calls backdrop (`ad-interstitial`); `fake-*` are the neutral
 * placeholder creatives the FakeAdProvider draws in test mode.
 */
export type AdOverlay =
  | { kind: 'interstitial'; phase: 'loading' | 'showing' }
  | { kind: 'fake-rewarded'; placement: RewardedPlacement; seconds: number; resolve: (r: 'granted' | 'closed') => void }
  | { kind: 'fake-interstitial'; seconds: number; resolve: () => void };

interface OverlayState {
  overlay: AdOverlay | null;
  set: (o: AdOverlay | null) => void;
}

export const useAdOverlay = create<OverlayState>((set) => ({
  overlay: null,
  set: (overlay) => set({ overlay }),
}));
